<table
  [dataSource]="data"
  cdkDropList
  [cdkDropListSortingDisabled]="true"
  [cdkDropListConnectedTo]="dropArea"
  cdk-table
>
  <ng-container cdkColumnDef="select">
    <th cdk-header-cell *cdkHeaderCellDef class="table-header" [style.width.px]="selectColumnWidthInPx">
      <wchfs-checkbox
        *ngIf="selection.isMultipleSelection()"
        color="primary"
        (change)="collectiveCheckboxChanged($event, data)"
        [checked]="selection.selected?.length === data?.length"
      ></wchfs-checkbox>
    </th>
    <td cdk-cell *cdkCellDef="let item" [style.width.px]="selectColumnWidthInPx">
      <wchfs-checkbox
        color="primary"
        (change)="rowCheckboxChanged($event, item)"
        [checked]="selection.isSelected(item)"
      ></wchfs-checkbox>
    </td>
  </ng-container>

  <ng-container *ngFor="let column of columns">
    <ng-container [cdkColumnDef]="column.getName()">
      <th
        cdk-header-cell
        *cdkHeaderCellDef
        class="table-header"
        [style.width]="column.getWidth()"
        [style.text-align]="column.getAlign()"
      >
        <div>
          {{ column.getHeader() | translate }}
        </div>
      </th>
      <td
        *cdkCellDef="let item"
        cdk-cell
        [style.width]="column.getWidth()"
        [style.overflow]="column.getOverflow()"
        [style.text-align]="column.getAlign()"
      >
        <ng-container [ngSwitch]="column.getContentType()">
          <ng-container
            *ngSwitchCase="GenericTableColumn.CONTENT_TYPE_TEMPLATE"
            [ngTemplateOutlet]="column.getTemplate()"
            [ngTemplateOutletContext]="{ item: item }"
          >
          </ng-container>
          <ng-container *ngSwitchDefault>
            {{ item[column.getName()] ? item[column.getName()] : '-' }}
          </ng-container>
        </ng-container>
      </td>
      <td
        *cdkFooterCellDef="let item"
        cdk-footer-cell
        [style.width]="column.getWidth()"
        [style.overflow]="column.getOverflow()"
        [style.text-align]="column.getAlign()"
      >
        <ng-container
          *ngIf="column.getFooterColumnTemplate() as template"
          [ngTemplateOutlet]="template"
          [ngTemplateOutletContext]="{ item: item }"
        >
        </ng-container>
      </td>
    </ng-container>
  </ng-container>
  @if (!config.withoutHeader) {
    <tr cdk-header-row *cdkHeaderRowDef="visibleColumns"></tr>
  }

  @if (config.isDraggable) {
    <tr
      class="drag-item"
      cdkDrag
      [cdkDragData]="item"
      cdk-row
      *cdkRowDef="let item; columns: visibleColumns"
      [class.highlighted-row]="isHighlighted(item)"
      [style]="item?.[GenericTableRowMeta.KEY]?.rowStyle"
    ></tr>
  } @else {
    <tr
      cdk-row
      *cdkRowDef="let item; columns: visibleColumns"
      [class.highlighted-row]="isHighlighted(item)"
      [style]="item?.[GenericTableRowMeta.KEY]?.rowStyle"
    ></tr>
  }

  @if (config.withFooterRow) {
    <tr cdk-footer-row *cdkFooterRowDef="visibleColumns"></tr>
  }
</table>

<!--<ng-container *ngIf="data?.length === 0">-->
<!--  <div class="empty-state">-->
<!--    <app-empty-state>{{ 'no-data' | translate }}</app-empty-state>-->
<!--  </div>-->
<!--</ng-container>-->

<app-table-loader-or-empty-state
  [listData]="{
    response: data,
    empty: data?.length === 0,
    loading: data === null || data === undefined,
    error: false,
    firstLoad: data === null || data === undefined,
  }"
  [title]="config.emptyStateTitle"
  [description]="config.emptyStateDescription"
></app-table-loader-or-empty-state>
